module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAAAAABWESUoAAAAF0lEQVQ4y2P8z4AfMI4qGFUwqmCkKgAA+C0gAU8qoK4AAAAASUVORK5CYII="